<template>
  <div class="user_container">
    <div class="container">
      <div
        class="home"
        v-if="activeIndex == 0"
        :style="{ height: 'calc(100vh - 67px)' }"
      >
        <div class="goback">
          <div @click="goback">
            <i class="el-icon-arrow-left"></i>
            <span>雷士公益</span>
          </div>
        </div>
        <div class="welfare_time">
          <div class="welfare_left">
            <div class="welfare_left_time">
              <span>{{ userinfo.hour }}</span
              >小时
            </div>
            <div class="welfare_left_text">爱心用户累计公益时长</div>
          </div>
          <div class="welfare_right" @click="chandleToRank">
            <div class="welfare_right_img">
              <img
                src="@/assets/newMedal/home/4.svg"
                alt=""
                style="width: 24px; height: 24px"
              />
            </div>
            <div class="welfare_right_text">排行榜</div>
          </div>
        </div>
        <div class="swiper" v-if="badgeList.length > 0">
          <swiper
            class="scrollItem"
            :options="swiperOptions"
            style="width: 100%"
          >
            <swiper-slide v-for="(item, index) in badgeList" :key="index">
              <div
                class="item_con"
                @click="
                  toDetail('/mobile/medal/publicWelfare/welfareDetail', item)
                "
              >
                <div class="title">
                  <div>{{ item.title }}</div>
                  <div
                    @click.stop="
                      toUrl('/mobile/medal/publicWelfare/welfareList')
                    "
                  >
                    更多
                  </div>
                </div>
                <div class="img" v-if="item?.image">
                  <img :src="imgUrl + item?.image" alt="" />
                </div>
                <div class="img" v-else>
                  <img src="@/assets/newMedal/publicWelfare/bg2.png" alt="" />
                </div>
                <div class="time">
                  <van-icon name="clock-o" style="margin-right: 8px" />
                  {{ item.startTime }}
                  <span style="margin: 0 5px">—</span> {{ item?.endTime }}
                </div>
                <div class="progress">
                  <el-progress
                    :text-inside="true"
                    :stroke-width="14"
                    :percentage="(item?.applyNum / item?.num) * 100"
                  ></el-progress>
                  <div class="progress_text">{{ item.num }}人</div>
                </div>
                <div
                  class="tag"
                  @click.stop="toMoreAooly('/mobile/medal/moreApply', item)"
                >
                  <div class="tag_item" v-for="(v, i) in item.headpic" :key="i">
                    <div class="tag_img">
                      <img :src="v.headpic" alt="" />
                    </div>
                    <div class="tag_name">{{ v.name }}</div>
                  </div>
                </div>
                <!-- <div class="btn">
                  <el-button
                    @click.stop="
                      toSubmit('/mobile/medal/publicWelfare/registration', item)
                    "
                  >
                    报名
                  </el-button>
                </div> -->
                <div class="btn" v-if="item.state == 1 && item.isApply == 0">
                  <el-button
                    @click.stop="
                      toSubmit('/mobile/medal/publicWelfare/registration', item)
                    "
                  >
                    报名
                  </el-button>
                </div>
                <div class="btn" v-if="item.state == 1 && item.isApply == 1">
                  <el-button @click.stop="noSignUp(item)"> 取消报名 </el-button>
                </div>
                <div class="swiper-pagination"></div>
              </div>
            </swiper-slide>
          </swiper>
        </div>
        <div class="contentCon">
          <div class="title">
            个人公益成果提报
            <span @click="toRouter('/mobile/medal/historyRecord')"
              >历史记录</span
            >
          </div>
          <div class="content">
            <div
              class="item"
              v-for="(item, index) in iconList"
              :key="index"
              @click="toUrl('/mobile/medal/publicWelfare/submitWelfare', item.type)"
            >
              <div class="item_img">
                <img :src="item.icon" alt="" />
              </div>
              <div class="item_text">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="my" :style="{ height: 'calc(100vh - 67px)' }">
        <My></My>
      </div>
      <div class="footer_con">
        <div
          class="footer_item"
          v-for="(item, index) in footerList"
          :key="index"
          @click="chandleFooter(item, index)"
        >
          <img :src="item.icon" alt="" style="width: 24px; height: 24px" />
          <div :class="activeIndex == index ? 'activeLabel' : 'label'">
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import My from "./my.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import api from "@/apis/publicWelfare";
import apis from "@/apis/medal";
import { getToken } from "@/utils/cookie";
import moment from "moment";
export default {
  name: "publicWelfare",
  props: {},
  components: {
    My,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      activeIndex: 0,
      footerList: [
        {
          icon: require("@/assets/newMedal/home/15.svg"),
          activeIcon: require("@/assets/newsNotice/activeHome.png"),
          label: "首页",
        },
        {
          icon: require("@/assets/newMedal/home/16.svg"),
          activeIcon: require("@/assets/newsNotice/activeMy.png"),
          label: "我的",
        },
      ],
      swiperOptions: {
        loop: false,
        autoplay: false,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      },
      badgeList: [],
      iconList: [
        {
          icon: require("@/assets/newMedal/publicWelfare/icon1.svg"),
          text: "无偿献血",
          type: 1
        },
        {
          icon: require("@/assets/newMedal/publicWelfare/icon2.svg"),
          text: "志愿服务",
          type: 2
        },
        // {
        //   icon: require("@/assets/newMedal/publicWelfare/icon3.svg"),
        //   text: "指尖公益",
        //   type: 3
        // },
        {
          icon: require("@/assets/newMedal/publicWelfare/icon4.svg"),
          text: "公益捐款",
          type: 4
        },
        // {
        //   icon: require("@/assets/newMedal/publicWelfare/icon5.svg"),
        //   text: "公益捐赠",
        //   type: 5
        // },
        // {
        //   icon: require("@/assets/newMedal/publicWelfare/icon6.svg"),
        //   text: "团队时长",
        // },
      ],
      userinfo: {},
      imgUrl: "",
    };
  },

  created() {},
  computed: {},
  mounted() {
    if (localStorage.getItem("publicWelfareActive")) {
      this.activeIndex = localStorage.getItem("publicWelfareActive");
      localStorage.removeItem("publicWelfareActive");
    }
    this.imgUrl = apis.imgUrl;
    this.getUserInfo();
    this.getInfoList();
  },
  beforeDestroy() {},
  methods: {
    // 返回
    goback() {
      this.$router.go(-1);
    },
    // 取消报名
    noSignUp(item) {
      api
        .cancel({
          activityId: item.id,
          empNo: getToken(),
        })
        .then(() => {
          this.getInfoList()
          this.$message({
            message: "取消报名成功",
            type: "success",
            duration: 2000,
          });
        });
    },
    chandleFooter(item, index) {
      this.activeIndex = index;
    },
    // 获取列表
    getInfoList() {
      api
        .homePage({
          year: "",
          place: 1,
          state: 1,
          empNo: getToken(),
        })
        .then((res) => {
          if (res.code == 200) {
            const data = res.data;
            data.forEach((item) => {
              item.startTime = moment(item.startTime).format(
                "YYYY/MM/DD HH:mm"
              );
              item.endTime = moment(item.endTime).format("YYYY/MM/DD HH:mm");
            });
            this.badgeList = data;
            this.badgeList.forEach((item) => {
              if (item.headpic.length > 4) {
                item.headpic = item.headpic.slice(0, 4);
              }
            });
            console.log(this.badgeList, "res111");
          }
        });
    },
    // 获取用户信息
    getUserInfo() {
      api
        .myPubBenefit({
          empNo: getToken(),
        })
        .then((res) => {
          if (res.code == 200) {
            console.log(res, "res222");
            this.userinfo = res.data;
          }
        });
    },
    // 跳转详情
    toUrl(path, index) {
      if (index || index == 0) {
        this.$router.push({
          path: path,
          query: {
            type: index,
          },
        });
      } else {
        this.$router.push({
          path: path,
        });
      }
    },
    // 跳转排行榜
    chandleToRank() {
      this.$router.push({
        path: "/mobile/medal/benefitRank",
      });
    },
    // 跳转详情
    toRouter(path) {
      this.$router.push(path);
    },
    // 提交报名
    toSubmit(path, item) {
      if (item?.applyNum == item?.num) {
        this.$message({
          type: "warning", // success error warning
          message: "当前活动报名人数已满",
          duration: 2000,
        });
      } else {
        this.$router.push({
          path: path,
          query: {
            itemUrl: JSON.stringify(item),
          },
        });
      }
    },
    // 跳转详情
    toDetail(path, item) {
      this.$router.push({
        path: path,
        query: {
          id: item.id,
        },
      });
    },
    // 跳转更多报名
    toMoreAooly(path, item) {
      this.$router.push({
        path: path,
        query: {
          id: item.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
    background: url("~@/assets/newMedal/publicWelfare/bg.png");
    background-size: 100% 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
    background: url("~@/assets/newMedal/publicWelfare/bg.png");
    background-size: 100% 100%;
  }
}

.user_container {
  min-height: 100vh;
  position: relative;
  margin: auto;
  font-size: 1vh;
  background-color: #ffffff;
  .container {
    width: 100%;
    height: 100%;
    .home {
      padding: 30px;
      overflow: auto;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      .welfare_time {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 30px;
        .welfare_left_time {
          color: black;
          font-size: 12px * $zoom;
          span {
            font-weight: bold;
            font-size: 20px * $zoom;
          }
        }
        .welfare_left_text {
          color: #666666;
          font-size: 10.8px * $zoom;
          margin-top: 10px;
        }
        .welfare_right {
          .welfare_right_img {
            margin-right: 10px;
            text-align: center;
          }
          .welfare_right_text {
            color: #666666;
            font-size: 9.5px * $zoom;
          }
        }
      }
      .swiper {
        width: 100%;
        margin: 20px auto 0;
        padding-bottom: 30px;
        background: #fff;
        border-radius: 25px;
        .item_con {
          padding: 30px;
          .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 30px;
            div:nth-child(1) {
              font-weight: bold;
              color: #000;
              font-size: 12px * $zoom;
              margin-right: 30px;
            }
            div:nth-child(2) {
              color: #666;
              font-size: 9.5px * $zoom;
              // 文字不换行
              white-space: nowrap;
            }
          }
          .img {
            width: 100%;
            height: 120px * $zoom;
            img {
              width: 100%;
              height: 100%;
              border-radius: 40px;
            }
          }
          .time {
            color: #666;
            font-size: 8px * $zoom;
            margin: 20px 0 25px;
          }
          .progress {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 30px;
            .progress_text {
              width: 40px * $zoom;
              text-align: center;
              font-size: 11px * $zoom;
            }
            ::v-deep {
              .el-progress {
                width: calc(100% - 40px * $zoom);
              }
              .el-progress-bar__inner {
                background: #75bfcf;
              }
              .el-progress-bar__innerText {
                opacity: 0;
              }
            }
          }
          .tag {
            display: flex;
            align-items: center;
            // justify-content: space-between;
            margin-bottom: 30px;
            .tag_item {
              margin-right: 40px;
            }
            .tag_img {
              img {
                width: 24px * $zoom;
                height: 24px * $zoom;
                border-radius: 50%;
              }
            }
            .tag_name {
              color: #666;
              font-size: 8px * $zoom;
              margin-top: 20px;
              text-align: center;
            }
          }
          .btn {
            text-align: center;
            button {
              background: #1fbe8a;
              color: #fff;
              border: none;
              font-size: 10.8px * $zoom;
              border-radius: 15px;
              width: 60%;
              height: 75px;
            }
          }
          ::v-deep {
            .swiper-pagination {
              width: 100%;
              height: 80px;
              // bottom: -3.9vh;
              margin-top: 10px;
              left: 0;
            }

            .swiper-pagination-bullet {
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: rgba(31, 190, 138, 1);
              margin: 0 5px;
            }
            .swiper-pagination-bullet-active {
              background-color: rgba(31, 190, 138, 1);
            }
          }
        }
      }
      .contentCon {
        .title {
          font-size: 30px;
          font-weight: bold;
          margin-left: 20px;
          margin-top: 30px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            font-size: 22px;
            color: #666;
            font-weight: normal;
          }
        }

        .content {
          display: flex;
          align-items: flex-start;
          flex-wrap: wrap;
          //   justify-content: space-between;
          margin-top: 25px;
          .item {
            width: 25%;
            margin-bottom: 20px;
            // margin-right: 10px;
          }
          .item_text {
            text-align: center;
            font-size: 8px * $zoom;
            margin-top: -10px;
          }
        }
      }
    }
    .my {
      overflow: auto;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
    }
  }
  .footer_con {
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 28px;
    height: 120px;
    width: 100%;
    background-color: #fff;
    .footer_item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .label {
        font-weight: 400;
        color: #bfbfbf;
        font-size: 22px;
      }
      .activeLabel {
        font-weight: 500;
        color: #303030;
        font-size: 22px;
      }
    }
  }
}

.goback {
  margin: 10px 40px 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}

@keyframes floatAndFade {
  0% {
    opacity: 0.3;
    /* 初始不透明度为1 */
  }

  50% {
    opacity: 0.7;
  }

  100% {
    opacity: 1;
  }
}
</style>
